import { Component, forwardRef } from '@angular/core';
import { BaseFormComponent } from '../../../widgets/global/BaseFormComponent';
import { FormControl, Validators, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { PhoneAreaCodeValidator } from 'src/app/validators/phone-area-code-validator'
import { PatternValidator } from '../../global/Validators';


@Component({
  standalone: false,
  selector: 'app-organiser-form',
  templateUrl: './organiser-form.component.html',
  styleUrls: ['./organiser-form.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OrganiserFormComponent),
    multi: true
  }]
})

export class OrganiserFormComponent extends BaseFormComponent {


  constructor(private phoneAreaCodeValidator: PhoneAreaCodeValidator) {
    super();
    this.form = new FormGroup({
      firstname: new FormControl('', [Validators.required, PatternValidator.noWhiteSpace()]),
      surname: new FormControl('', [Validators.required, PatternValidator.noWhiteSpace()]),
      email: new FormControl('', [Validators.required, PatternValidator.email()]),
      phone: new FormControl('', [
        PatternValidator.phone(),
        phoneAreaCodeValidator.validateAreaCode()
      ])
    });

    this.onValueChanged(p => {
      this.setValues(p.firstname as string, p.surname as string, p.email as string, p.phone as string);
    });

    this.form.valueChanges.subscribe(values => {
      this.value.firstname = values.firstname ? values.firstname.trim() : values.firstname;
      this.value.surname = values.surname ? values.surname.trim() : values.surname;
      this.value.email = values.email;
      this.value.phone = values.phone;
    });
  }

  setValues(firstname: string, surname: string, email:string, phone:string){
    this.form.get('firstname').setValue(firstname);
    this.form.get('surname').setValue(surname);
    this.form.get('email').setValue(email);

    // sets the default value for phone field
    if(phone)
      this.form.get('phone').setValue(phone);
    // else
    //   this.form.get('phone').setValue("+353");
  }
}
